/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { WriteOperation } from './';
import {
    WriteOperationFromJSON,
    WriteOperationFromJSONTyped,
    WriteOperationToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateAdvancedSearchRequest
 */
export interface UpdateAdvancedSearchRequest {
    /**
     * 
     * @type {Array<WriteOperation>}
     * @memberof UpdateAdvancedSearchRequest
     */
    operations: Array<WriteOperation>;
}

/**
 * Check if a given object implements the UpdateAdvancedSearchRequest interface.
 */
export function instanceOfUpdateAdvancedSearchRequest(value: object): value is UpdateAdvancedSearchRequest {
    if (!('operations' in value) || value['operations'] === undefined) return false;
    return true;
}

export function UpdateAdvancedSearchRequestFromJSON(json: any): UpdateAdvancedSearchRequest {
    return UpdateAdvancedSearchRequestFromJSONTyped(json, false);
}

export function UpdateAdvancedSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAdvancedSearchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'operations': ((json['operations'] as Array<any>).map(WriteOperationFromJSON)),
    };
}

export function UpdateAdvancedSearchRequestToJSON(value?: UpdateAdvancedSearchRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'operations': ((value['operations'] as Array<any>).map((v) => WriteOperationToJSON(v))),
    };
}

